// THE ONE PLACE client-facing branding lives on the front end. Anything printed on a document a
// client sees — company name, phone, logo — comes from here, so a rebrand is one edit rather than
// a hunt.
//
// ⛔ IT IS NOT YET THE ONLY PLACE IN THE REPO, and pretending otherwise would be worse than saying
// so. "National Tax Resource Group" is currently written out in seven files (App.js:149,
// ClientUpload.js:398, four mailto bodies in TaskEngine.js, build-tbt-eml.js:92), and the logo
// exists as a 121 KB base64 literal in api/generate-transmittal.js (its stray copy under src/pages was
// deleted 2026-10-07). Consolidating those is a separate change; this file is where
// new code should read from, and where the others should eventually point.
//
// ⛔ THE LOGO IS AN ASSET IMPORT, NOT A DATA URI. The server-side renderer keeps its copy at
// lib/ntrgLogo.js (a data URI, because a serverless bundle cannot read the filesystem), but CRA's
// ModuleScopePlugin forbids importing anything outside src/, and inlining a second 121 KB base64
// literal here would put it in the main bundle for every page load. src/assets/ntrg-logo.png is
// decoded from lib/ntrgLogo.js — same image, emitted by webpack as a URL and fetched only by the
// screens that actually render it. If the logo changes, change both.

import ntrgLogo from '../assets/ntrg-logo.png';

export const COMPANY_NAME = 'National Tax Resource Group';
export const COMPANY_SHORT = 'NTRG';

// Appears on every page of the analyst's reports. Consumers must still treat NULL as "omit the
// line" rather than "print an empty space" — the footer is written that way deliberately, so a
// future rebrand can blank a field without leaving a gap on a client document.
export const COMPANY_PHONE = '682-626-6687';

export const COMPANY_LOGO = ntrgLogo;
export const COMPANY_LOGO_ASPECT = 3.4259;   // width / height, from lib/ntrgLogo.js

// Brand red, matching --red in the app's CSS variables. @react-pdf has no access to CSS custom
// properties, so the literal is needed there; keep the two in step.
export const BRAND_RED = '#B40000';
export const BRAND_INK = '#1c1c1c';
export const BRAND_MUTED = '#6b6658';
